import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ManagementTabsRoutingModule } from './management-tabs-routing.module';
import { ManagementTabsComponent } from './management-tabs.component';
import { MyPersonalDataModule } from '../my-personal-data/my-personal-data.module';
import { RegionManagementModule } from '../region-management/region-management.module';
import { ReleaseNoteAdminModule } from '../release-note-admin/release-note-admin.module';
import { UserListModule } from '@app/user-list/user-list.module';
import { MunicipalityOnboardingModule } from '@app/municipality-onboarding/municipality-onboarding.module';
import { MunicipalityManagementModule } from '@app/municipality-management/municipality-management.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ManagementTabsRoutingModule,
    MyPersonalDataModule,
    MunicipalityManagementModule,
    RegionManagementModule,
    ReleaseNoteAdminModule,
    UserListModule,
    MunicipalityOnboardingModule,
  ],
  declarations: [ManagementTabsComponent],
})
export class ManagementTabsModule { }
